import { enqueueSnackbar } from 'notistack';
import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const createCleanEntry = async (user, data) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `/service/events_service/v1/events/event/clear/entry`,
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${accessToken}`,
            user,
        },
        data,
    };

    try {
        const response = await axios.request(config);
        return response?.data;
    } catch (error) {
        console.log(error);

        if (error?.data === "Verification timeout") {
            return;
        }
        if (error?.status === 401) {
            enqueueSnackbar("Un Authorized Request", {
                variant: "error",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
            logout();
        }
        enqueueSnackbar(error?.data?.message || error?.data || error.message, {
            variant: "error",
            anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        });
    }
};

export default createCleanEntry;
